import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { processErrorDetails } from '#utils/errorArrayDetails';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useCreateListStore = defineStore('createList', {
  state: () => ({
    createListResponse: {},
    createListError: null,
    createListErrorDetails: null,
    createListLoadingState: false,
    createListErrorStatus: false,
  }),
  actions: {
    async createList({ payload, headers }) {
      this.createListLoadingState = true;
      this.createListErrorStatus = false;
      this.createListError = null;
      try {
        const response = await $http.post(`${WISHLIST_ENDPOINT}/`, payload, {
          headers,
        });
        const responseData = response.data || response;
        if (!getError(responseData)) {
          const data = responseData?.CustomerList || {};
          this.createListResponse = data;
          this.createListErrorDetails = null;
        } else {
          const errorObj = getError(responseData);
          const errorDetails = processErrorDetails(errorObj);
          this.createListError = getErrorMessage(responseData, 'GENERIC');
          this.createListErrorDetails = errorDetails;
          this.createListResponse = {};
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.createListErrorStatus = true;
        }
        const data = error?.response?.data;
        const errorObj = getError(data);
        const errorDetails = processErrorDetails(errorObj);
        this.createListError = getErrorMessage(error, 'BAD_REQUEST');
        this.createListErrorDetails = errorDetails;
        this.createListResponse = {};
      } finally {
        this.createListLoadingState = false;
      }
    },
    setCreateList(lists) {
      this.createListResponse = lists;
    },
    setCreateListError(error) {
      this.createListError = error;
    },
    setCreateListErrorDetails(errorDetails) {
      this.createListErrorDetails = errorDetails;
    },
    setCreateListLoadingState(loadValue) {
      this.createListLoadingState = loadValue;
    },
    setCreateListErrorStatus(value) {
      this.createListErrorStatus = value;
    },
  },
});
